import gql from 'graphql-tag.macro';

const query = gql`
  query getUnreadMessages {
    unreadMessagesInfo {
      unreadMessages {
        id
        sender {
          id
          avatarUrl
          fullName
        }
        job {
          id
          jobRequest {
            id
            requestName
            startDate
          }
        }
        createdAt
        body
      }
      totalUnreadMessagesCount
    }
  }
`;

const reducer = (payload) => payload.unreadMessagesInfo;

export const getUnreadMessages = {
  query,
  reducer,
};
